import React from "react";
import "./userdashboardhomepage.css";
import { RiLuggageDepositLine } from "react-icons/ri";
import { MdOutlineDone } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { FaUser } from "react-icons/fa";
import { MdOutlineContentCopy } from "react-icons/md";
import { FiLink } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import { FaExchangeAlt } from "react-icons/fa";
import { CgArrowsExchange } from "react-icons/cg";
import Loader from "../Loader";
import axios from "axios";
import { FaGift } from "react-icons/fa";
import { FaCoins } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";

const Userdashboardhomepage = ({ route }) => {
  const navigate = useNavigate();
  const [clipBoard, setClipBoard] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [cryptoAssets, setCryptoAssets] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [cryptoBalances, setCryptoBalances] = useState({});

  const copy = () => {
    navigator.clipboard.writeText(clipRef.current.value);
  };
  const clipRef = useRef(null);

  const calculateCryptoBalances = (transactions) => {
    const balances = {};
    transactions.forEach(transaction => {
      if (transaction.status === "completed" && transaction.type === "deposit") {
        const cryptoName = transaction.method;
        if (cryptoName) {
          balances[cryptoName] = (balances[cryptoName] || 0) + (transaction.amount || 0);
        }
      }
    });
    
    return balances;
  };

  useEffect(() => {
    if (transactions.length > 0) {
      const balances = calculateCryptoBalances(transactions);
      setCryptoBalances(balances);
    }
  }, [transactions]);

  useEffect(() => {
    const fetchCryptoAssets = async () => {
      try {
        const response = await axios.get(
          `${route}/crypto-assets/public/active`
        );
        if (response.data.status === "ok") {
          setCryptoAssets(response.data.assets);
          
        }
      } catch (error) {
        console.error("Error fetching crypto assets:", error);
      }
    };

    fetchCryptoAssets();
  }, [route]);
  useEffect(() => {
    const getData = async () => {
      try {
        setLoader(true);

        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        // Fetch user data
        const response = await axios.get(`${route}/auth/getData`, {
          headers: {
            "x-access-token": token,
          },
        });

        const data = response.data;
        setUserData(data);

        // Fetch staking data
        const stakingResponse = await axios.get(
          `${route}/staking/stakes`,
          {
            headers: {
              "x-access-token": token,
            },
          }
        );

        // Calculate totals
        const totalStaked = stakingResponse.data.reduce(
          (acc, stake) => acc + stake.amount,
          0
        );

        const activeStakes = stakingResponse.data.filter(
          stake => stake.status === 'active'
        ).length;

        // Fetch rewards
        const rewardsResponse = await axios.get(
          `${route}/staking/rewards`,
          {
            headers: {
              "x-access-token": token,
            },
          }
        );

        setUserData(prev => ({
          ...prev,
          totalStaked,
          activeStakes,
          totalRewards: rewardsResponse.data.totalRewards,
          stakes: stakingResponse.data
        }));

        // Fetch user's transactions
        const transactionsResponse = await axios.get(
          `${route}/ledger/transactions`,
          {
            headers: {
              "x-access-token": token,
            },
          }
        );

        // Calculate totals from transactions
        const transactions = transactionsResponse.data;
        setTransactions(transactions)
        const totalDeposits = transactions
          .filter((t) => t.type === "deposit" && t.status === "completed")
          .reduce((acc, t) => acc + t.amount, 0);
        const totalWithdrawals = transactions
          .filter((t) => t.type === "withdrawal" && t.status === "completed")
          .reduce((acc, t) => acc + t.amount, 0);

        // Calculate crypto balances from transactions



        setUserData((prev) => ({
          ...prev,
          totalDeposit: totalDeposits,
          totalWithdrawal: totalWithdrawals,
          transactions: transactions,
        }));

        setLoader(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      }
    };

    getData();
  }, [navigate, route]);

  return (
    <div className="homewrapper">
      {loader && <Loader />}
      <div className="dashboardhomepage">
        <div className="dashboardhomepagewrapper">
          {/* <div className="welcome-kyc-section">
                <p>wallet Balance</p>
                <div className="username-container">
                    <h2>${userData ? userData.funded : ''}.00 USD</h2>
                </div>
            </div> */}

          {/* Add new stats cards section */}
          <div className="stats-cards-container">
            <div className="stats-card">
              <div className="icon-wrapper purple">
                <span className="dollar-icon">$</span>
              </div>
              <div className="stats-info">
                <h3>${userData?.balance?.toFixed(2) || "0.00"}</h3>
                <p>Ledger Balance</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="icon-wrapper blue">
                <span className="stake-icon">
                  <FaCoins />
                </span>
              </div>
              <div className="stats-info">
                <h3>${userData?.totalStaked?.toFixed(2) || "0.00"}</h3>
                <p>Total Staked</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="icon-wrapper green">
                <span className="rewards-icon">
                  <FaGift />
                </span>
              </div>
              <div className="stats-info">
                <h3>${userData?.totalRewards?.toFixed(2) || "0.00"}</h3>
                <p>Total Rewards</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="icon-wrapper orange">
                <span className="active-stakes-icon">
                  <FaChartLine />
                </span>
              </div>
              <div className="stats-info">
                <h3>{userData?.activeStakes || 0}</h3>
                <p>Active Stakes</p>
              </div>
            </div>

            {/* Add crypto balance cards */}
            {cryptoAssets.map(crypto => (
              <div className="stats-card" key={crypto.name}>
                <div className="icon-wrapper purple">
                  <img src={crypto.logoUrl} width={24} height={24} alt={crypto.name} className="crypto-icon" />
                </div>
                <div className="stats-info">
                  <h3>{cryptoBalances[crypto.symbol] || "0.00"}</h3>
                  <p className="crypto-balance-text">{crypto.name} Balance</p>
                </div>
              </div>
            ))}
          </div>

          <div className="dash-btn-container">
            <button className="dash-btn" onClick={() => navigate("/fundwallet")}>
              <CgArrowsExchange />
              Fund Ledger
            </button>
            <button className="dash-btn" onClick={() => navigate("/plans")}>
              <FaCoins />
              Stake Now
            </button>
          </div>
          <div className="overview-container">
            <div className="overview-card">
              <div
                className="overview-icon-wrapper"
                onClick={() => navigate("/myprofile")}
              >
                <div className="overview-icon-container">
                  <FaUser />
                </div>
                <small>profile</small>
              </div>
              <div
                className="overview-icon-wrapper"
                onClick={() => navigate("/plans")}
              >
                <div className="overview-icon-container">
                  <RiLuggageDepositLine />
                </div>
                <small>Stake</small>
              </div>
              <div
                className="overview-icon-wrapper"
                onClick={() => navigate("/investments")}
              >
                <div className="overview-icon-container">
                  <FaChartLine />
                </div>
                <small>Staking History</small>
              </div>
              <div
                className="overview-icon-wrapper"
                onClick={() => navigate("/transactions")}
              >
                <div className="overview-icon-container">
                  <FaExchangeAlt />
                </div>
                <small>Funding History</small>
              </div>
              <div
                className="overview-icon-wrapper"
                onClick={() => navigate("/referrals")}
              >
                <div className="overview-icon-container">
                  <FaUsers />
                </div>
                <small>referrals</small>
              </div>
            </div>
          </div>
          <div className="price-chart-section">
            <iframe
              src="https://widget.coinlib.io/widget?type=chart&theme=light&coin_id=859&pref_coin_id=1505"
              style={{
                width: "100%",
                height: "536px",
                scrolling: "none",
                marginWidth: "0",
                marginHeight: "0",
                frameBorder: "0",
                border: "0",
                lineHeight: "14px",
              }}
              title="Crypto Chart"
            ></iframe>
          </div>
          <div className="referral-section">
            <div className="referral-card">
              <div className="referraltext-wrapper">
                <div className="referral-text-container">
                  <h2>refer us and earn 10% of every downline deposit</h2>
                  <p>Use the below link to invite your friends.</p>
                </div>
                <div className="click-to-copy-container">
                  <span className="clipboard-btn">
                    <FiLink />
                  </span>
                  <input
                    type="text"
                    value={
                      userData
                        ? `${window.location.origin}/user/${userData.referralCode}`
                        : ""
                    }
                    ref={clipRef}
                    readOnly
                  />
                  <span
                    className="clipboard-btn"
                    onClick={() => {
                      copy();
                      setClipBoard(true);
                      setTimeout(() => setClipBoard(false), 2000);
                    }}
                  >
                    {clipBoard ? <MdOutlineDone /> : <MdOutlineContentCopy />}
                  </span>
                </div>
              </div>
            </div>
            <div className="referral-card1">
              <div className="referraltext-wrapper">
                <div className="referral-text-container">
                  <h2>my referrals</h2>
                </div>
                <div className="referral-text-container small-card">
                  <h2>{userData?.referredUsers?.length || 0}</h2>
                  <p>referred users</p>
                </div>
                <div className="referral-text-container small-card">
                  <h2>
                    ${userData ? userData.referralBonus.toFixed(2) : "0.00"} USD
                  </h2>
                  <p>referral commission</p>
                </div>
              </div>
              <img src="/bar4.png" alt="" className="bar4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userdashboardhomepage;
